<template>
  <div class="flex flex-col mb-6">
    <div class="flex flex-wrap gap-4 w-full">
      <b-input
        :disabled="loading"
        :value="value"
        class="sm:w-full w-100"
        placeholder="搜尋訂購ID、例行性ID、訂購名稱或訂購標籤"
        @keypress.enter.native="onSearch"
        @input="$emit('input', $event)"
      />
      <div class="flex gap-6 overflow-x-auto">
        <w-button
          :disabled="loading || isSubmitDisabled"
          class="flex-shrink-0"
          size="sm"
          @click="onSearch"
        >
          搜尋
        </w-button>
        <w-button
          :disabled="loading"
          class="flex-shrink-0"
          color-type="secondary"
          size="sm"
          type="link"
          @click="$emit('clear')"
        >
          清除
        </w-button>
        <w-button
          class="flex-shrink-0"
          size="sm"
          type="link"
          @click="openedFilter = !openedFilter"
        >
          <span>進階篩選</span>
          <i
            :class="openedFilter ? 'icon-up-chevron' : 'icon-down-chevron'"
            class="ml-2"
          />
        </w-button>
      </div>
    </div>
    <div
      v-if="openedFilter"
      class="bg-light-gray-400 flex flex-wrap gap-4 items-center mt-2 px-4 py-2 rounded"
    >
      <div class="flex flex-wrap gap-y-4 items-center">
        <label class="mr-3 text-gray-500 text-sm">查詢日期範圍</label>
        <b-radio
          :disabled="loading"
          v-model="type"
          class="mr-4"
          name="date_type"
          native-value="start"
        >
          依開放訂購日
        </b-radio>
        <b-radio
          :disabled="loading"
          v-model="type"
          name="date_type"
          native-value="receive"
        >
          依領取起始日
        </b-radio>
      </div>
      <b-field class="w-[312px]">
        <b-datepicker
          v-model="selectedDates"
          :date-formatter="dateFormatter"
          :disabled="loading"
          :first-day-of-week="1"
          :min-date="minDate"
          :max-date="maxDate"
          icon="calendar-alt"
          locale="zh-TW"
          placeholder="請選擇日期範圍"
          range
        />
      </b-field>
    </div>
  </div>
</template>

<script>
import OrderSearch from './OrderSearch';

export default OrderSearch;
</script>

<style lang="scss" scoped>
@import 'OrderSearch';
</style>
